import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'disableGiftCardTopupScreen',
  initialState: true,
  reducers: {
    setDisableGiftCardTopupScreen(state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { setDisableGiftCardTopupScreen } = slice.actions;

export default slice.reducer;
